<div class="flex flex-col justify-center text-center text-center bg-white rounded-xl p-2">
  <div class="mt-5 w-full md:w-[576px] ml-auto mr-auto" *ngIf="sessionResources.session.value() as session">
    <div class="flex flex-col w-full justify-center items-left text-theme-black text-left pl-2 pr-2 " *ngIf="leadResources.currentLead.value() as lead">

      <p class="font-theme-source text-2xl "><span class="font-bold">Merci {{lead.firstname}}</span> !</p>
      <p class="font-theme-source text-xl mt-5 font-bold" [ngSwitch]="referralCode() != null">
        <span *ngSwitchCase="true">La soirée de ton ami(e)</span>
        <span *ngSwitchCase="false">Ta soirée</span>
      </p>
      <p class="font-theme-source text-md font-light mt-1">{{lead.offer.title}}.</p>
      <p class="font-theme-source text-md font-light">
        <span *ngIf="session.topic != 'lgbt_w' && lead.sex == 'F'">Avec un homme de</span>
        <span *ngIf="session.topic == 'lgbt_w'|| lead.sex == 'M'">Avec une femme
          <span *ngIf="lead?.topicSearchOptions?.length == 2">homosexuelle ou lesbienne</span>
          <span *ngIf="lead?.topicSearchOptions?.length == 1 && lead?.topicSearchOptions?.includes('FF')">homosexuelle</span>
          <span *ngIf="lead?.topicSearchOptions?.length == 1 && lead?.topicSearchOptions?.includes('FB')">bisexuelle</span>
          de</span>

        {{lead.subscription?.desiredSearchAgeMin}} à {{lead.subscription?.desiredSearchAgeMax}} ans.
      </p>

      <p class="font-theme-source text-xl mt-5 font-bold">Date et lieu de ta soirée</p>
      <p class="font-theme-source text-md font-light mt-1">{{session.date | showEventDatetime}}</p>
      <p class="font-theme-source text-md font-light">{{session.shortDescription}}</p>

      <p class="font-theme-source text-xl font-bold mt-5" >Ton paiement</p>
      <p class="font-theme-source text-md font-light" *ngIf="lead.subscription.paid">Paiement effectué.</p>
      <p class="font-theme-source text-md font-light" *ngIf="!lead.subscription.paid && lead.subscription.payment.payMode == 'bank_transfer'">
        Paiement de <span class="font-bold">{{lead.subscription.payment.amount | showPrice}}</span>&nbsp;
        <span *ngIf="!lead.subscription.paid">à effectuer par virement bancaire (informations fournies par Email)</span>
        <span *ngIf="lead.subscription.paid">Paiement reçu le {{lead.subscription?.paidAt | showEventDate}}</span>.
      </p>
      <p class="font-theme-source text-md font-light" *ngIf="!lead.subscription.paid && lead.subscription.payment.payMode == 'in_place'">
        Paiement de <span class="font-bold">{{lead.subscription.payment.amount | showPrice}}</span> à effectuer sur place en CB ou comptant en Espèces.
      </p>
      <p class="font-theme-source text-md font-light" *ngIf="lead.subscription.paid && lead.subscription.offered">Billet offert.</p>

      <p class="font-theme-source text-md mt-5 mb-5 font-light"><span class="font-bold">Si tu viens avec des ami(e)s</span>, contacte Sébastien pour l'informer :
        <a href="mailto:sebastien@7minutespourtoi.fr" aria-label="Envoyer Email">sebastien&#64;7minutespourtoi.fr</a>.</p>

      <p class="font-theme-source text-2xl mt-5 font-bold">Remplis ton profil amoureux !</p>
      <p class="font-theme-source text-md font-light mt-1">Il nous permettra de te faire rencontrer des célibataires compatibles avec ta personnalité et ta recherche.</p>
      <p class="mt-5 mb-5">
        <a [routerLink]="['/love-profile']" aria-label="Profil amoureux" target="_blank">
          <app-lp-button class="w-full block" text="Révéler mon profil amoureux (gratuit)" ></app-lp-button>
        </a>
      </p>

      <p *ngIf="lead.subscription.paid" class="font-theme-source text-2xl mt-5 font-bold">Inscris un(e) ami(e) !</p>
      <p *ngIf="lead.subscription.paid" class="font-theme-source text-md font-light mt-1">Elle/Il bénéficiera d'une réduction de plus de 4€ sur son billet.</p>
      <p *ngIf="lead.subscription.paid" class="mt-5 mb-5">
        <a>
          <app-lp-button class="w-full block" text="Inscris un(e) ami(e) maintenant" (onClick)="subscribeFriendNow()"></app-lp-button>
        </a>
      </p>

      <p class="font-theme-source text-2xl mt-5 font-bold">Nous restons à ta disposition !</p>
      <p class="font-theme-source text-md font-light mt-1">Pour toute information ou problème concernant ton inscription, Sébastien reste à ta disposition par Email à l'adresse
        <span class="font-bold text-theme-red-110">
          <a aria-label="Envoyer Email" href="mailto:sebastien@7minutespourtoi.fr">sebastien&#64;7minutespourtoi.fr</a>.
        </span>
      </p>
    </div>
  </div>
</div>


